export default "__VITE_ASSET__696fc03c__"